import Header from '../../components/Header'
import Footer from '../../components/Footer'
import SignForm from '../../components/SignForm'

function Register() {
    return (
        <div>
            <Header></Header>
            <SignForm></SignForm>
            <Footer></Footer>
        </div>
    )
}

export default Register